'use client';
import { useRef } from 'react';
import { useShopProduct } from '@/hooks/useShopProduct';
import LoadingApp from '@/components/LoadingApp';
import BuyBar from './BuyBar';
import OrderCard from './OrderCard';
import ProductCard from './ProductCard';
import SpecificationsCard from './SpecificationsCard';
import { classes } from './utils';

export default function StorefrontPage() {
  const orderCardRef = useRef<HTMLDivElement>(null);
  const { product } = useShopProduct();

  if (!product) return <LoadingApp />;

  return (
    <>
      <div className={classes.storefront}>
        <div className={classes.leftColumn}>
          <ProductCard />
          <SpecificationsCard />
        </div>
        <div ref={orderCardRef} className={classes.rightColumn}>
          <OrderCard />
        </div>
      </div>
      <BuyBar orderCardRef={orderCardRef} />
    </>
  );
}
